import {
  PaginationTableSiePedidos,
} from "@/store/modules/sie-pedidos/states/table";
import { PaginationTableLotes } from "@/store/modules/sie-pedidos/states/tableLotes";
import dayjs from "dayjs";
import {Detalhamento, Solicitacao} from "@/models/sie-pedidos/solicitacao";
import FunctionsCommuns from "@/util/FunctionsCommuns";
import {Lote} from "@/models/sie-pedidos/lote";

export default {
  ["SET_FORM_STEP"](state: any, value: Number): void {
    state.dadosForm.currentStep = value;
  },
  ["SET_TABLE_CONTENT"](state: any, value: Solicitacao[]): void {
    state.table.content = value?.map(v=>(
      {numeroSolicitacao: v.numeroSolicitacao,
        cpf: FunctionsCommuns.formatCPF(v.cpf),
        situacao: v.situacao, tipoSolicitacao: v.tipoSolicitacao,
        dataSolicitacao: FunctionsCommuns.formatBRDateHora(v.dataSolicitacao),
        motivo: v.motivo, id: v.numeroSolicitacao,
        loteId: v.loteId}));
  },
  ["SET_TABLE_LOADING"](state: any, value: Boolean): void {
    state.table.isLoading = value;
  },
  ["SET_TABLE_TOTALS"](state: any, value: Number): void {
    state.table.total = value;
  },
  ["SET_TABLE_PAGINATION"](state: any, value: PaginationTableSiePedidos): void {
    state.table.paginate = value;
  },
  ["CLEAR_TABLE"](state: any): void {
    state.table.paginate = {
        id: null,
        numeroSolicitacao: null,
        cpf: null,
        status: null,
        tipoSolicitacao: null,
        startDate: null,
        endDate: null,
        page: 0,
        size: 10,
    };
  },
  ["SET_TABLE_LOTES_CONTENT"](state: any, value: Lote[]): void {
    state.tableLotes.content = value?.map(v=>({
      id: v.id,
      enviarSindonibus: v.situacao==="Lote Recebido Pela Gráfica",
      entidadeSigla: v.entidadeSigla,
      situacao: v.situacao,
      createdDate: FunctionsCommuns.formatBRDateHora(v.createdDate),
      graficaNomeFantasia: v?.graficaNomeFantasia
    }));
  },
  ["SET_TABLE_LOTES_LOADING"](state: any, value: Boolean): void {
    state.tableLotes.isLoading = value;
  },
  ["SET_TABLE_LOTES_TOTALS"](state: any, value: Number): void {
    state.tableLotes.total = value;
  },
  ["SET_TABLE_LOTES_PAGINATION"](
    state: any,
    value: PaginationTableLotes
  ): void {
    state.tableLotes.paginate = value;
  },
  ["CLEAR_TABLE_LOTES"](state: any): void {
    state.tableLotes.paginate = {
        id: null,
        numeroLote: null,
        status: null,
        data: null,
        startDate: null,
        endDate: null,
        page: 0,
        size: 10
    };
  },
  ["SET_TIPO_SOLICITACAO"](state: any, value: String): void {
    state.form.tipoSolicitacaoId = value;
  },
  ["SET_DOCUMENTO_FOTO"](state: any, file: File | null): void {
    state.form.documentoFoto = file;
  },
  ["SET_DADOS_FORM_SOLICITACAO"](state: any, value: any): void {
    const semNumero = value.aluno?.numero === 'S/N'
    state.form.aluno = {
      ...value.aluno,
      dataNascimento: value.aluno?.id
        ? FunctionsCommuns.formatBRDate(value?.aluno?.dataNascimento)
        : null,
      enderecoPayload: {
        cep: FunctionsCommuns.formatCEP(value.aluno?.cep),
        bairro: value.aluno?.bairro,
        logradouro: value.aluno?.logradouro,
        municipio: value.aluno?.municipio,
        numero: semNumero ? null : value.aluno?.numero,
        semNumero: semNumero
      },
    };
    state.form.alunoId = value.aluno?.id;
    state.form.documentoFoto = value.aluno?.documentoFoto;
    state.form.documentoRg = value.aluno?.documentoRg;
    state.form.documentoCpf = value.aluno?.documentoCpf;
    state.form.documentoResponsavel = value.aluno?.documentoResponsavel;
    state.form.documentoComprovanteMatricula = value.aluno?.documentoComprovanteMatricula;
    state.form.documentoComprovanteResidencia = value.aluno?.documentoComprovanteResidencia;
    state.form.documentoFichaCadastral = value.aluno?.documentoFichaCadastral;

  },
  ["SET_DADOS_FORM_ENDERECO"](state: any, value: any): void {
    state.form.aluno.enderecoPayload = { ...value, cep: FunctionsCommuns.formatCEP(value.cep)};
  },
  ["SET_DADOS_PARA_SOLICITACAO"](state: any, value: any): void {
    state.dadosForm.dadosParaSolicitacao = value.dadosParaSolicitacao;
  },
  ["SET_CPF"](state: any, value: String): void {
    state.form.cpf = value;
  },
  ["SET_DADOS_FILTER_SOLICITACAO"](state: any, value: object): void {
    state.table.dadosFilterSolicitacao = value;
  },
  ['CLEAR_DADOS_FORM_SOLICITACAO'](state, value): void{
    state.form.aluno = {
      enderecoPayload: {
      },
    };
    state.form.documentoCpf = null;
    state.form.documentoComprovanteMatricula = null;
    state.form.documentoFoto = null;
    state.form.documentoResponsavel = null;
    state.form.documentoFichaCadastral = null;
    state.form.documentoRg = null;
    state.form.lgpd = null;
  },
  ["SET_SHOW_MODAL_SOLICITACAO_ALUNO"](state: any, value: object): void {
    state.aluno = {...state, ...value}
  },
  ['SET_DETALHAMENTO_SOLICITACAO'](state: any, value: Detalhamento){
    const {id, aluno, tipoSolicitacao, motivo, situacaoSolicitacao, listDocumentos, dataSolicitacao} = value || {}
    state.detalhamento = {
            id, tipoSolicitacao,
            situacaoSolicitacao,
            aluno, listDocumentos,
            cpf: FunctionsCommuns.formatCPF(aluno.cpf),
            motivo,
            dataSolicitacao: FunctionsCommuns.formatBRDateHora(dataSolicitacao)}
  },
  ['SET_DADOS_FILTER_GRAFICA'](state: any, value: object){
    state.tableLotes.dadosFilterLotes = {...value}
  }
};
